<template>
  <main id="pages-ingredients-ingredients-content" class="ragnarok">
    <right-sidebar-layout page-title="Ingredients" :breadcrumbs="breadcrumbs">
      <template #left>
        <section v-if="hasMostPopular" class="popular section is-borderless">
          <h4 class="title is-4">Most Popular</h4>
          <div class="columns">
            <div
                class="ingredient column"
                v-for="(ingredient, i) in popularIngredients"
                :key="i"
            >
              <a :href="ingredientUrl(ingredient.urlKey)">
                <b-image class="card is-animated" :src="ingredient.imageUrl" :alt="ingredient.name">
                  <!-- <b-skeleton height="194px" slot="placeholder"></b-skeleton> -->
                </b-image>
              </a>
              <span class="caption">{{ ingredient.name }}</span>
            </div>
          </div>
        </section>

        <section class="all-ingredients section is-borderless">
          <h4 class="title is-4">All Ingredients</h4>
          <div class="columns is-multiline">
            <div
                class="column is-6"
                v-for="(ingredient, i) in ingredients"
                :key="i"
            >
              <a :href="ingredientUrl(ingredient.urlKey)">
                <horizontal-marketing-card
                    :title="ingredient.name"
                    :img-src="ingredient.imageUrl"
                    :condense-width="300"
                    :min-height="100"
                    centered
                    no-badge
                ></horizontal-marketing-card>
              </a>
            </div>
          </div>
        </section>
      </template>

      <template #right>
        <section class="our-ingredients section">
          <h4 class="title is-4">
            <i class="icon fa-fw fal fa-mortar-pestle"></i>
            Our Ingredients
          </h4>
          <p>
            Thorne cares deeply about where our ingredients come from. Our
            research and development team is tasked with sourcing exceptional
            ingredients, maintaining oversight of an ingredient's origin, and
            providing complete supply chain transparency.
          </p>
          <p>
            We partner only with suppliers whose practices emphasize quality,
            science, and environmental responsibility. We believe that better
            ingredients mean better potency, absorption, and digestibility -
            and ultimately better health.
          </p>
        </section>

        <section class="committed-clean section">
          <h4 class="title is-4">
            <i class="icon fa-fw fal fa-leaf-heart"></i>
            Committed to 100% Clean
          </h4>
          <p>
            At Thorne, clean describes supplements that do not contain any
            harmful or unnecessary ingredients. Our "No" List guides us every
            day in choosing which ingredients to source and how to formulate
            new products, so you can feel confident about what you are putting
            in your body.
          </p>
          <a class="is-underlined" href="/thorne-no-list">See our No List</a>
        </section>
      </template>
    </right-sidebar-layout>
  </main>
</template>

<script>
import RightSidebarLayout from "~/components/layouts/RightSidebarLayout.vue";
import HorizontalMarketingCard from "~/components/marketing/HorizontalMarketingCard.vue";

export default {
  name: "IngredientsPage",

  components: {
    RightSidebarLayout,
    HorizontalMarketingCard,
  },

  data() {
    return {
      ingredients: ingredients,
      popularIngredients: popularIngredients,
      breadcrumbs: [
        { uri: "/", name: "Home" },
        { uri: "/ingredients/details", name: "Ingredients" },
      ],
    }
  },

  computed: {
    hasMostPopular() {
      return this.popularIngredients.length > 0;
    }
  },

  methods: {
    ingredientUrl(urlKey) {
      return `/ingredients/${urlKey}`;
    },
  },
}
</script>

<style lang="scss" scoped>
// To do after Nuxt, do not have variables and mixins accessible
</style>